/**
 * @deprecated Superseded by {@link PermissionDtoString}
 */
export enum PermissionName {
  COMPLETE_TASK_LIST_ACCESS = 'COMPLETE_TASKLIST_ACCESS',
  ORIGINAL_TAG_ACCESS = 'ORIGINAL_TAG_ACCESS',
  LOCKED_INDEX_EDIT = 'LOCKED_INDEX_EDIT',
  VIEW_ACCESS = 'VIEW_ACCESS',
  MULTIUSER_CREATE = 'MULTIUSER_CREATE',
  PACKAGE_ASSIGN = 'PACKAGE_ASSIGN',
  PRE_ACCESS = 'PRE_ACCESS',
  PRE_OR_INDEX_OWNER_ACCESS = 'PRE_OR_INDEX_OWNER_ACCESS',
  PRM_WRITE = 'PRM_WRITE',
  TRANSMITTAL_LOCKED_TAGS_REMOVE = 'TRANSMITTAL_LOCKED_TAGS_REMOVE',
  TRANSMITTAL_OPEN_TAGS_REMOVE = 'TRANSMITTAL_OPEN_TAGS_REMOVE',
  TRANSMITTAL_REVIEW = 'TRANSMITTAL_REVIEW',
  PRM_DISC_IMPORT = 'PRM_DISC_IMPORT',
  PRM_FULL_IMPORT = 'PRM_FULL_IMPORT',
  DOCUMENT_PROFILE_CURRENT_ACCESS = 'DOCUMENT_PROFILE_CURRENT_ACCESS',
  DOCUMENT_PROFILE_LOCKED_EDIT = 'DOCUMENT_PROFILE_LOCKED_EDIT',
  DOCUMENT_PROFILE_SUBMIT = 'DOCUMENT_PROFILE_SUBMIT',
  TAG_PROFILE_SUBMIT = 'TAG_PROFILE_SUBMIT',
  MODEL_3D_PROFILE_LOCKED_EDIT = 'MODEL_3D_PROFILE_LOCKED_EDIT',
  MODEL_3D_PROFILE_SUBMIT = 'MODEL_3D_PROFILE_SUBMIT',
  MODEL_3D_PROFILE_CURRENT_ACCESS = 'MODEL_3D_PROFILE_CURRENT_ACCESS',
  INTERFACE_PROFILE_LOCKED_EDIT = 'INTERFACE_PROFILE_LOCKED_EDIT',
  INTERFACE_PROFILE_CURRENT_ACCESS = 'INTERFACE_PROFILE_CURRENT_ACCESS',
  INTERFACE_PROFILE_SUBMIT = 'INTERFACE_PROFILE_SUBMIT',
  PROJECT_SETUP_ACCESS = 'PROJECT_SETUP_ACCESS',
  PROJECT_DASHBOARD_ACCESS = 'PROJECT_DASHBOARD_ACCESS',
  SUPPLIER_DASHBOARD_ACCESS = 'SUPPLIER_DASHBOARD_ACCESS',
  PROJECT_INTERNAL_CREATE = 'PROJECT_INTERNAL_CREATE',
  DRYRUN_FEEDBACK_ACCESS = 'DRYRUN_FEEDBACK_ACCESS',
  DOCUMENTFILE_ADMIN = 'DOCUMENTFILE_ADMIN',
}

/**
 * Copied from {@link /../client-api/src/main/java/com/akersolutions/push/trim/model/security/TrimPermission.java}
 */
export type PermissionDtoString =
  | 'TRANSMITTAL_ACCESS'
  | 'LOCKED_INDEX_EDIT'
  | 'TRANSMITTAL_VIEW_SUBMITTED'
  | 'VIEW_ACCESS'
  | 'PROJECT_ACCESS'
  | 'PACKAGE_ACCESS'
  | 'ORIGINAL_TAG_ACCESS'
  | 'VERSIONED_TAG_VIEW'
  | 'PROJECT_PACKAGE_ACCESS'
  | 'PACKAGE_ASSIGN'
  | 'PROJECT_SETUP_ACCESS'
  | 'USER_SETUP_ACCESS'
  | 'SUPPLIER_SETUP'
  | 'CLIENT_SETUP'
  | 'TRANSMITTAL_REVIEW'
  | 'PRM_VIEW'
  | 'PRM_WRITE'
  | 'DISCIPLINE_ASSIGNABLE'
  | 'COMPLETE_TASKLIST_ACCESS'
  | 'MULTIUSER_CREATE'
  | 'DISCIPLINE_ACCESS'
  | 'PRM_FULL_IMPORT'
  | 'PRM_DISC_IMPORT'
  | 'DOCUMENT_SUPPLIER_READY'
  | 'DELIVERABLE_APPROVE'
  | 'DELIVERABLE_BASIC_ACCESS'
  | 'DELIVERABLE_ACCESS'
  | 'DELIVERABLE_CREATE'
  | 'DOCUMENT_PROFILE_CURRENT_ACCESS'
  | 'DOCUMENT_PROFILE_LOCKED_EDIT'
  | 'DOCUMENT_PROFILE_SUBMIT'
  | 'INTERFACE_PROFILE_CURRENT_ACCESS'
  | 'INTERFACE_PROFILE_LOCKED_EDIT'
  | 'INTERFACE_PROFILE_SUBMIT'
  | 'MODEL_3D_PROFILE_CURRENT_ACCESS'
  | 'MODEL_3D_PROFILE_LOCKED_EDIT'
  | 'MODEL_3D_PROFILE_SUBMIT'
  | 'DISTRIBUTION_VIEW'
  | 'DISTRIBUTION_WRITE'
  | 'DISTRIBUTION_DISCIPLINE_WRITE'
  | 'TAGADMIN_ACCESS'
  | 'APPROVED_DELIVERABLE_FIRST_DUE_EDIT'
  | 'PROJECT_INTEGRATION_EDIT'
  | 'PROJECT_DASHBOARD_ACCESS'
  | 'SUPPLIER_DASHBOARD_ACCESS'
  | 'PROJECT_ALL_PACKAGES_PRE_ACCESS'
  | 'INDEX_HISTORY_AUTHOR_DETAILS_VIEW'
  | 'TAG_PROFILE_SUBMIT'
  | 'ORIGINAL_TAGS_VIEW'
  | 'DELIVERABLE_FULL_EXPORT'
  | 'DELIVERABLE_PACKAGE_EXPORT'
  | 'PROJECT_INTERNAL_CREATE'
  | 'PROJECT_INTERNAL_DELETE'
  | 'DRYRUN_FEEDBACK_ACCESS'
  | 'SIDRL_TEMPLATE_READ'
  | 'SIDRL_TEMPLATE_WRITE'
  | 'SIDRL_READ'
  | 'SIDRL_WRITE'
  | 'DOCUMENTFILE_ADMIN'
  | 'CDF_OPERATION_ACCESS'
  | 'CDF_OPERATION_GLOBAL_ACCESS'
  | 'PROFILE_PROPERTY_VERSIONED_WRITE';
